import { getLegacyTemplateFieldValue } from "./templateLegacyCompatibility";

export const TEMPLATE_CATEGORY_IDS = {
  PRIVATE_PROVIDER: "094bd961-141e-44d3-a84f-21e097d550f7",
  ENGINEER: "3f2570fc-d0ce-4ed4-aa16-68120a8edc3b",
  ARCHITECT: "174c9be6-82b2-45cf-8fb1-176d29ecd5d5",
  DESIGN_PROFESSIONAL: "7e80126d-083b-40a0-b0ed-baf92eeaf4ee",
  FEE_SIMPLE: "dd01e0c5-5ee4-4d42-b46e-8eb61e0deab6",
  BONDING: "7f26a819-c2ac-4a6d-866e-6500bc9b69c8",
  MORTGAGE: "d3f81ed2-b564-48d7-bd38-60f014853a0c",
};

export const TEMPLATE_CATEGORY_CONFIG = {
  [TEMPLATE_CATEGORY_IDS.PRIVATE_PROVIDER]: {
    label: "Private Provider Details",
    selectorName: "privateProvider",
    selectLabel: "Select Private Provider",
    listKey: "privateProvider",
    displayFields: ["pp_company_name", "companyName", "pp_name"],
    addingState: "addingNewPrivateProvider",
    loadingState: "privateProviderLoading",
    removeModalState: "privateProviderConfirmModalOpen",
    aliases: {
      pp_company_name: ["pp_company_name", "companyName"],
      pp_address: ["pp_address", "address", "fullAddress", "pp_full_address"],
      pp_phone: ["pp_phone", "phone", "mobile"],
      pp_email: ["pp_email", "email"],
      pp_name: ["pp_name", "name", "licenseName", "pp_full_name"],
      pp_license: ["pp_license", "license", "licenseNumber", "pp_license_num"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.ENGINEER]: {
    label: "Engineer Details",
    selectorName: "engineerDesignProfessional",
    selectLabel: "Select Engineer",
    listKey: "designProfessional",
    displayFields: ["companyName", "licenseName", "licenseNumber"],
    addingState: "addingNewDesignPro",
    loadingState: "designProLoading",
    removeModalState: "addDesignProConfirmOpen",
    aliases: {
      engineer: ["engineer", "licenseName", "companyName"],
      engineer_name: ["engineer_name", "licenseName", "companyName"],
      engineerName: ["engineerName", "licenseName", "companyName"],
      engineer_company: ["engineer_company", "companyName"],
      engineerCompany: ["engineerCompany", "companyName"],
      engineer_license: ["engineer_license", "licenseNumber"],
      engineerLicense: ["engineerLicense", "licenseNumber"],
      engineer_license_number: ["engineer_license_number", "licenseNumber"],
      engineerLicenseNumber: ["engineerLicenseNumber", "licenseNumber"],
      engineer_address: ["engineer_address", "address", "fullAddress"],
      engineerAddress: ["engineerAddress", "address", "fullAddress"],
      engineer_street: ["engineer_street", "street", "address1"],
      engineerStreet: ["engineerStreet", "street", "address1"],
      engineer_city: ["engineer_city", "city"],
      engineerCity: ["engineerCity", "city"],
      engineer_state: ["engineer_state", "state"],
      engineerState: ["engineerState", "state"],
      engineer_zip: ["engineer_zip", "zip", "zipCode"],
      engineerZip: ["engineerZip", "zip", "zipCode"],
      engineer_phone: ["engineer_phone", "phone", "mobile"],
      engineerPhone: ["engineerPhone", "phone", "mobile"],
      engineer_mobile: ["engineer_mobile", "mobile", "phone"],
      engineerMobile: ["engineerMobile", "mobile", "phone"],
      engineer_fax: ["engineer_fax", "fax"],
      engineerFax: ["engineerFax", "fax"],
      engineer_email: ["engineer_email", "email"],
      engineerEmail: ["engineerEmail", "email"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.ARCHITECT]: {
    label: "Architect Details",
    selectorName: "architectDesignProfessional",
    selectLabel: "Select Architect",
    listKey: "designProfessional",
    displayFields: ["companyName", "licenseName", "licenseNumber"],
    addingState: "addingNewDesignPro",
    loadingState: "designProLoading",
    removeModalState: "addDesignProConfirmOpen",
    aliases: {
      architect: ["architect", "licenseName", "companyName"],
      architect_name: ["architect_name", "licenseName", "companyName"],
      architectName: ["architectName", "licenseName", "companyName"],
      architect_company: ["architect_company", "companyName"],
      architectCompany: ["architectCompany", "companyName"],
      architect_license: ["architect_license", "licenseNumber"],
      architectLicense: ["architectLicense", "licenseNumber"],
      architect_license_number: ["architect_license_number", "licenseNumber"],
      architectLicenseNumber: ["architectLicenseNumber", "licenseNumber"],
      architect_address: ["architect_address", "address", "fullAddress"],
      architectAddress: ["architectAddress", "address", "fullAddress"],
      architect_street: ["architect_street", "street", "address1"],
      architectStreet: ["architectStreet", "street", "address1"],
      architect_city: ["architect_city", "city"],
      architectCity: ["architectCity", "city"],
      architect_state: ["architect_state", "state"],
      architectState: ["architectState", "state"],
      architect_zip: ["architect_zip", "zip", "zipCode"],
      architectZip: ["architectZip", "zip", "zipCode"],
      architect_phone: ["architect_phone", "phone", "mobile"],
      architectPhone: ["architectPhone", "phone", "mobile"],
      architect_mobile: ["architect_mobile", "mobile", "phone"],
      architectMobile: ["architectMobile", "mobile", "phone"],
      architect_fax: ["architect_fax", "fax"],
      architectFax: ["architectFax", "fax"],
      architect_email: ["architect_email", "email"],
      architectEmail: ["architectEmail", "email"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.DESIGN_PROFESSIONAL]: {
    label: "Design Professional",
    selectorName: "designProfessional",
    selectLabel: "Select Design Professional",
    listKey: "designProfessional",
    displayFields: ["companyName", "design_pro_company", "licenseNumber"],
    addingState: "addingNewDesignPro",
    loadingState: "designProLoading",
    removeModalState: "addDesignProConfirmOpen",
    aliases: {
      design_pro_company: ["design_pro_company", "companyName"],
      design_pro_license_name: ["design_pro_license_name", "licenseName"],
      design_pro_license_num: ["design_pro_license_num", "licenseNumber"],
      design_pro_address: ["design_pro_address", "address", "fullAddress"],
      design_pro_street: ["design_pro_street", "street", "address1"],
      design_pro_city: ["design_pro_city", "city"],
      design_pro_state: ["design_pro_state", "state"],
      design_pro_zip: ["design_pro_zip", "zip", "zipCode"],
      design_pro_phone: ["design_pro_phone", "phone", "mobile"],
      design_pro_fax: ["design_pro_fax", "fax"],
      design_pro_email: ["design_pro_email", "email"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.FEE_SIMPLE]: {
    label: "Fee Simple Details",
    selectorName: "feeSimpleTitleholder",
    selectLabel: "Select Fee Simple Title Holder Contact",
    listKey: "feeSimple",
    displayFields: ["fee_simple_name"],
    addingState: "addingNewFeeSimple",
    loadingState: "feeSimpleLoading",
    removeModalState: "feeSimpleConfirmModalOpen",
    aliases: {
      fee_simple_name: ["fee_simple_name", "name"],
      feeSimple: ["fee_simple_name", "name"],
      fee_simple_address: ["fee_simple_address", "address", "fullAddress"],
      feeSimpleAddress: ["fee_simple_address", "address", "fullAddress"],
      fee_simple_street: ["fee_simple_street", "street", "address1"],
      feeSimpleStreet: ["fee_simple_street", "street", "address1"],
      fee_simple_city: ["fee_simple_city", "city"],
      feeSimpleCity: ["fee_simple_city", "city"],
      fee_simple_state: ["fee_simple_state", "state"],
      feeSimpleState: ["fee_simple_state", "state"],
      fee_simple_zip: ["fee_simple_zip", "zip", "zipCode"],
      feeSimpleZip: ["fee_simple_zip", "zip", "zipCode"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.BONDING]: {
    label: "Bonding Company Details",
    selectorName: "bondingCompany",
    selectLabel: "Select Bonding Company",
    listKey: "bonding",
    displayFields: ["bonding_name"],
    addingState: "addingNewBonding",
    loadingState: "bondingLoading",
    removeModalState: "bondingConfirmModalOpen",
    aliases: {
      bonding_name: ["bonding_name", "name"],
      bonding: ["bonding_name", "name"],
      bonding_address: ["bonding_address", "address", "fullAddress"],
      bondingAddress: ["bonding_address", "address", "fullAddress"],
      bonding_street: ["bonding_street", "street", "address1"],
      bondingStreet: ["bonding_street", "street", "address1"],
      bonding_city: ["bonding_city", "city"],
      bondingCity: ["bonding_city", "city"],
      bonding_state: ["bonding_state", "state"],
      bondingState: ["bonding_state", "state"],
      bonding_zip: ["bonding_zip", "zip", "zipCode"],
      bondingZip: ["bonding_zip", "zip", "zipCode"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.MORTGAGE]: {
    label: "Mortgage Lender's Details",
    selectorName: "mortgageLender",
    selectLabel: "Select Mortgage Lender",
    listKey: "mortgageLender",
    displayFields: ["mortgage_name"],
    addingState: "addingNewMortgage",
    loadingState: "mortgageLoading",
    removeModalState: "mortgageConfirmModalOpen",
    aliases: {
      mortgage_name: ["mortgage_name", "name"],
      mortgageName: ["mortgage_name", "name"],
      lender: ["mortgage_name", "name"],
      lenderName: ["mortgage_name", "name"],
      mortgage_address: ["mortgage_address", "address", "fullAddress"],
      mortgageAddress: ["mortgage_address", "address", "fullAddress"],
      lenderAddress: ["mortgage_address", "address", "fullAddress"],
      mortgage_street: ["mortgage_street", "street", "address1"],
      mortgageStreet: ["mortgage_street", "street", "address1"],
      lenderStreet: ["mortgage_street", "street", "address1"],
      mortgage_city: ["mortgage_city", "city"],
      mortgageCity: ["mortgage_city", "city"],
      lenderCity: ["mortgage_city", "city"],
      mortgage_state: ["mortgage_state", "state"],
      mortgageState: ["mortgage_state", "state"],
      lenderState: ["mortgage_state", "state"],
      mortgage_zip: ["mortgage_zip", "zip", "zipCode"],
      mortgageZip: ["mortgage_zip", "zip", "zipCode"],
      lenderZip: ["mortgage_zip", "zip", "zipCode"],
    },
  },
};

export const getTemplateCategoryConfig = (categoryId) =>
  TEMPLATE_CATEGORY_CONFIG[categoryId] || null;

export const getTemplateDisplayName = (template, config) => {
  for (const key of config?.displayFields || []) {
    if (template?.[key]) return template[key];
  }

  const displayFieldSet = new Set(config?.displayFields || []);
  const dynamicDisplayKey = Object.entries(config?.aliases || {}).find(
    ([key, aliases]) =>
      template?.[key] &&
      [key, ...(aliases || [])].some((alias) => displayFieldSet.has(alias)),
  )?.[0];

  if (dynamicDisplayKey) return template[dynamicDisplayKey];

  return "Unnamed";
};

const hasOwnValue = (object, key) =>
  Boolean(object && key) &&
  Object.prototype.hasOwnProperty.call(object, key) &&
  object[key] !== undefined &&
  object[key] !== null;

const unwrapFieldValue = (value) =>
  value &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  "value" in value
    ? value.value
    : value;

const toCamelCase = (value = "") =>
  String(value).replace(/_([a-z0-9])/g, (_, character) =>
    character.toUpperCase(),
  );

const getLegacyFieldNameVariants = (fieldName) => {
  if (!fieldName) return [];

  const variants = [fieldName];
  const addressPartMatch = fieldName.match(
    /^(.*)_address_(street|city|state|zip)$/,
  );

  if (addressPartMatch) {
    const [, prefix, part] = addressPartMatch;
    variants.push(`${prefix}_${part}`);

    // Older saved-project records stored the street/full-address value under
    // keys such as feeSimpleAddress, bondingAddress, or mortgageAddress.
    if (part === "street") variants.push(`${prefix}_address`);
  }

  return [...new Set([...variants, ...variants.map(toCamelCase)])];
};

const isCanonicalLegacyKey = (key) =>
  typeof key === "string" && !key.includes("_");

const getReverseAliasKeys = (nameVariants, config) => {
  const variantSet = new Set(nameVariants);

  return Object.entries(config?.aliases || {})
    .filter(([key, aliases]) =>
      [key, ...(aliases || [])].some((candidate) => variantSet.has(candidate)),
    )
    .map(([key]) => key)
    .sort(
      (first, second) =>
        Number(isCanonicalLegacyKey(second)) -
        Number(isCanonicalLegacyKey(first)),
    );
};

const getTemplateFieldValue = (template, field, config) => {
  const fieldId = field?.field_id;
  const fieldValues = template?.field_values || template?.fieldValues;

  // field_id is the stable relationship between a category field and its
  // saved value. Prefer it over names because document field names can vary
  // between forms even when they point to the same default field.
  if (hasOwnValue(fieldValues, fieldId)) {
    return {
      found: true,
      value: unwrapFieldValue(fieldValues[fieldId]),
    };
  }

  if (hasOwnValue(template, fieldId)) {
    return { found: true, value: unwrapFieldValue(template[fieldId]) };
  }

  // Backward compatibility for records saved before field_values existed.
  const nameVariants = getLegacyFieldNameVariants(field?.name);
  const reverseAliasKeys = getReverseAliasKeys(nameVariants, config);
  const aliases = [
    ...reverseAliasKeys,
    ...nameVariants,
    ...nameVariants.flatMap((name) => config?.aliases?.[name] || []),
  ];
  const matchedAlias = [...new Set(aliases)].find((key) =>
    hasOwnValue(template, key),
  );

  const legacyValue = getLegacyTemplateFieldValue(template, field, config);

  if (legacyValue.found) {
    return legacyValue;
  }

  return matchedAlias
    ? { found: true, value: unwrapFieldValue(template[matchedAlias]) }
    : { found: false, value: undefined };
};

export const buildTemplateFieldValues = (template, fields, config) =>
  (fields || []).reduce((values, field) => {
    if (!field?.name) return values;

    const fieldValue = getTemplateFieldValue(template, field, config);
    return fieldValue.found
      ? { ...values, [field.name]: fieldValue.value }
      : values;
  }, {});

// The selector's own value (e.g. "designProfessional") is never part of the
// document's saved field data — it only ever lived in local formik state at
// selection time. Any time formik.values gets replaced with fresh field
// data (initial load, or the setValues/resetForm that runs right after a
// successful save) that key comes back empty even though the underlying
// fields still match a saved template. This reverse-matches the current
// field values against the user's saved templates so the dropdown can be
// re-selected without touching the save/load flow itself.
export const findMatchingTemplate = (
  templates,
  fields,
  config,
  currentValues,
) => {
  if (!templates?.length || !fields?.length || !config) return null;

  let bestMatch = null;
  let bestScore = 0;

  templates.forEach((template) => {
    const templateValues = buildTemplateFieldValues(template, fields, config);
    const keys = Object.keys(templateValues).filter(
      (key) => templateValues[key] !== undefined && templateValues[key] !== "",
    );
    if (!keys.length) return;

    // Require every populated field this template would have filled to
    // match the current form value — a partial match risks selecting the
    // wrong template when two saved templates share a value.
    const allMatch = keys.every(
      (key) =>
        String(currentValues?.[key] ?? "") === String(templateValues[key]),
    );

    if (allMatch && keys.length > bestScore) {
      bestScore = keys.length;
      bestMatch = template;
    }
  });

  return bestMatch;
};
